import type { FC } from 'react';
import { memo } from 'react';

import { AsyncSelect, type IAsyncSelectProps } from '@procurify/ui'

import { type Requester } from '@webapp/models/Requester'
import { ApiClient } from '@webapp/services/api'
import messages from './messages'

export const loadRequesters: IAsyncSelectProps['loadOptions'] = (
  inputValue,
  pagination,
  callback
) => {
  const params = {
    order_by: 'firstName',
    search: inputValue,
    is_active: true,
    page: pagination.page,
  }
  ApiClient.get<Requester[]>('/api/v3/users/requesters', {
    params,
  }).then((res) => {
    callback({
      options: res.data,
      pagination: {
        hasMore: !!res.metadata.pagination.next,
        page: pagination.page + 1,
      },
    })
  })
}

export interface IRequesterSelectProps extends IAsyncSelectProps<Requester> {}

export const RequesterSelect: FC<IRequesterSelectProps> = memo(
  (props) => (
    <AsyncSelect<Requester>
      placeholder='Select a user...'
      cacheOptions={true}
      defaultOptions={true}
      loadOptions={loadRequesters}
      getOptionLabel={(option) => `${option.firstName} ${option.lastName}`}
      getOptionValue={(option) => (option.id ? option.id.toString() : null)}
      isClearable={true}
      {...props}
    />
  )
)

RequesterSelect.displayName = 'RequesterSelect'
